module.exports = __webpack_public_path__ + "img/csr_swiper_01_mobile.e1cf4fc0.jpg";